const roleList = (state = {}, action) => {
  switch (action.type) {
    case "saveRolesList":
      return action.payload;
    default:
      return state;
  }
};

export default roleList;
